import { render, staticRenderFns } from "./TeacherCourseProjectDetail.vue?vue&type=template&id=12a6932d&scoped=true"
import script from "./TeacherCourseProjectDetail.vue?vue&type=script&lang=js"
export * from "./TeacherCourseProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseProjectDetail.vue?vue&type=style&index=0&id=12a6932d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6932d",
  null
  
)

export default component.exports